class DetailsModal extends HTMLElement {
 constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    const closeBtn = this.querySelector('button[type="button"]');

    if (this.detailsContainer) {
      this.detailsContainer.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });
    }

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.summaryToggle.setAttribute('role', 'button');
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', this.close.bind(this));
    }
  }


  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

close(focusToggle = true) {
  if (typeof removeTrapFocus === 'function') {
    removeTrapFocus(focusToggle && this.summaryToggle ? this.summaryToggle : null);
  }

  this.detailsContainer?.removeAttribute('open');

  if (this.onBodyClickEvent) {
    document.body.removeEventListener('click', this.onBodyClickEvent);
  }

  document.body.classList.remove('overflow-hidden');
}

}

customElements.define('details-modal', DetailsModal);
